import { render } from "./LinkRichText.vue?vue&type=template&id=340cc08b"
import script from "./LinkRichText.vue?vue&type=script&lang=js"
export * from "./LinkRichText.vue?vue&type=script&lang=js"

import "./LinkRichText.vue?vue&type=style&index=0&id=340cc08b&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__